/* eslint-disable consistent-return */
import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { ModalProps } from "react-bootstrap";
import uuid from "react-uuid";
import PaginationLocal from "../../components/PaginationLocal";
import GenericUtils from "../../utils/GenericUtils";
import TableStyles from "../../styles/components/TableStyles";
import AcademicActivityPlanService from "../../service/Docente/AcademicActivityPlanService";

export interface IActivityPlanHistoric extends ModalProps {
    teachingActivityPlanId: number;
    hideApproverProfile?: boolean;
}

const AcademicActivityPlanEndHistoric: React.FC<IActivityPlanHistoric> = ({
    teachingActivityPlanId,
}) => {
    const { instance } = useMsal();
    const [filteredData, setFilteredData] = useState<string[]>([]);
    const [info, setInfo] = useState<Array<string>>([""]);

    const getHistoricData = async () => {
        try {
            const response =
                await AcademicActivityPlanService.getEndTachHistory(
                    teachingActivityPlanId,
                    instance
                );

            if (GenericUtils.isSuccessStatus(response)) {
                if (response.data.itens) {
                    setInfo(response.data.itens);
                    setFilteredData(response.data.itens);
                }
                return response.data;
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    };

    useEffect(() => {
        getHistoricData();
    }, []);

    const formatDate = (date: string) => {
        const dataObjeto = new Date(date);
        const day = dataObjeto.getDate().toString().padStart(2, "0");
        const month = (dataObjeto.getMonth() + 1).toString().padStart(2, "0");
        const year = dataObjeto.getFullYear().toString();

        const hour = dataObjeto.getHours();
        const minutes = dataObjeto.getMinutes();

        return `${day}/${month}/${year} ${hour}:${minutes}`;
    };

    const bodyOfTable = filteredData?.map((item: any) => {
        return (
            <tr key={uuid()}>
                <td>{item.nomeQuemFinalizou}</td>
                <td>{item.matriculaQuemFinalizou}</td>
                <td>{item.perfilQuemFinalizou}</td>
                <td>{formatDate(item.created)}</td>
                <td>{item.justificativa}</td>
            </tr>
        );
    });

    return (
        <>
            <TableStyles.TablePrimary
                bordered
                striped
                responsive
                style={{ marginBottom: 0 }}
            >
                <thead>
                    <tr>
                        <th>Finalizado por</th>
                        <th>Matrícula</th>
                        <th>Perfil</th>
                        <th>Data e hora da finalização</th>
                        <th>Justificativa</th>
                    </tr>
                </thead>
                <tbody>
                    {info.length === 0 ? (
                        <tr>
                            <td colSpan={5}>Informações indisponíveis.</td>
                        </tr>
                    ) : (
                        bodyOfTable
                    )}
                </tbody>
            </TableStyles.TablePrimary>
            <PaginationLocal
                items={info}
                itemsPage={10}
                onPaginate={(data) => setFilteredData(data)}
                hidePagination={false}
            />
        </>
    );
};

export default AcademicActivityPlanEndHistoric;
